

































import {Vue, Component, Prop} from "vue-property-decorator";
import {UserInfoModel} from "@/model/user-info/user-info.model";
import {Message} from "@/message";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";

@Component
export default class UserInfoChangeMailAddress extends Vue {
    @Prop() private isVisible!: boolean;
    @Prop() private model!: UserInfoModel;
    mailAddress:string = "";
    reMailAddress:string = "";
    reInputMailErrorMsg:string = "";
    inputMailErrorMsg:string = "";

    save() {
        if(!this.checkMail()) { return }

        axios.put("/email/change-mail-address", { mail: this.mailAddress })
            .then(cb => {
                // ダイアログをクローズする
                this.$emit('close', this.mailAddress);
                // 画面遷移する
                window.location.href = cb.data;
            })
            .catch(error => {
                // HTTPステータスコード「400」でメッセージIDが設定されている場合
                if (error.response && (error.response.status == 400)) {
                    if (error.response.data) {
                        // メッセージIDに対応するメッセージをエラーメッセージに設定
                        this.inputMailErrorMsg = Message[error.response.data];
                        return;
                    }
                }
                AxiosUtils.gotoClientErrorPage(error, this.$router)
            });
    }

    checkMail(): boolean {
        let result: boolean;
        if(!this.mailAddress || this.mailAddress == "") {
            result = false;
            this.inputMailErrorMsg = Message.NOT_INPUT_MAIL;
        } else if(!(/^(?=[a-zA-Z0-9][a-zA-Z0-9@._%+-]{1,253}$)[a-zA-Z0-9._%+-]{1,64}@(?:(?=[a-zA-Z0-9-]{1,63}\.)[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.){1,64}[a-zA-Z0-9]{1,63}$/.test(this.mailAddress)) || this.mailAddress.length > 80) {
            result = false;
            this.inputMailErrorMsg = Message.WRONG_MAIL;
        } else if(this.mailAddress == this.model.mail) {
            result = false;
            this.inputMailErrorMsg = Message.INPUT_ANOTHER_MAIL
        } else {
            result = true;
            this.inputMailErrorMsg = "";
        }
        if(!this.reMailAddress || this.reMailAddress == "") {
            result = false;
            this.reInputMailErrorMsg = Message.NOT_INPUT_MAIL;
        } else if(this.mailAddress != this.reMailAddress) {
            result = false;
            this.reInputMailErrorMsg = Message.NOT_SAME_MAIL;
        } else if(!(/^(?=[a-zA-Z0-9][a-zA-Z0-9@._%+-]{1,253}$)[a-zA-Z0-9._%+-]{1,64}@(?:(?=[a-zA-Z0-9-]{1,63}\.)[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.){1,64}[a-zA-Z0-9]{1,63}$/.test(this.mailAddress)) || this.reMailAddress.length > 80) {
            result = false;
            this.reInputMailErrorMsg = Message.WRONG_MAIL;
        } else {
            this.reInputMailErrorMsg = "";
        }
        return result;
    }

    close() {
        this.mailAddress = "";
        this.reMailAddress = "";
        this.reInputMailErrorMsg = "";
        this.inputMailErrorMsg = "";
        this.$emit('close', null);
    }
}
